"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesDialogMode = void 0;
let FavoritesDialogMode = exports.FavoritesDialogMode = /*#__PURE__*/function (FavoritesDialogMode) {
  FavoritesDialogMode["Default"] = "Default";
  FavoritesDialogMode["Create"] = "Create";
  FavoritesDialogMode["Delete"] = "Delete";
  FavoritesDialogMode["Edit"] = "Edit";
  return FavoritesDialogMode;
}({});
